module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ded"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("To US Army Command Sergeant Major Kevin Griffin, US Army Major Tom Kennedy, US Air Force Major David Gray, USAID Foreign Service Officer Ragaei Abdelfattah, and your families. I will never forget you, nor will the grateful nation for which you made the ultimate sacrifice.")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('p', {
    staticClass: "dedr"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("—FLO GROBERG")])]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_vm._v("To my grandparents, Canio and Hedy Sileo and Clarence and Betty Luther. Your sacrifices during World War II helped pave the way for future generations of American heroes.")]), _vm._v(" "), _c('p', {
    staticClass: "dedr"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("—TOM SILEO")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a307caa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 72
// module chunks = 0